import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {PaymentPreparationDTO} from '../model/paymentPreparationDTO';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  private readonly path = environment.baseUrl + environment.apiPrefix + 'payment';

  constructor(private http: HttpClient) {
  }

  prepare(clientId: number, reportId: number) {
    let params = new HttpParams();
    params = params.append('clientId', clientId.toString());
    params = params.append('reportId', reportId.toString());
    return this.http.get<PaymentPreparationDTO>(`${this.path}/prepare`, {params: params});
  }

  enableRecurringPayments() {
    return this.http.get<void>(`${this.path}/recurring-payments/enable`);
  }

  disableRecurringPayments() {
    return this.http.get<void>(`${this.path}/recurring-payments/disable`);
  }

  gift(clientId: number, year: number) {
    return this.http.get<void>(`${this.path}/client/${clientId}/gift/${year}`);
  }
}
